import React from "react";
import CTASection from "../components/CTASection";
import { company, stats, whyChooseUs } from "../mock";
import { Target, Eye, HeartHandshake } from "lucide-react";
import useSeo from "../hooks/useSeo";

const About = () => {
  useSeo({
    title: "About | DODD-Certified Home Care Agency in Columbus, Ohio | Caregivers Alliance",
    description: "Caregivers Alliance Homecare is a Columbus-based, DODD-certified home care agency serving families across Ohio with compassionate, person-centered care and a fairly-paid caregiver workforce.",
    keywords: "DODD certified agency Ohio, home care agency Columbus Ohio, about Caregivers Alliance Homecare",
    path: "/about",
  });
  return (
    <>
      <section className="brand-gradient text-white">
        <div className="mx-auto max-w-7xl px-4 py-16">
          <h1 className="font-display font-extrabold text-4xl md:text-5xl">About Caregivers Alliance</h1>
          <p className="mt-4 text-white/90 max-w-2xl">
            A Columbus-based home care agency built on compassion, reliability and respect — for our clients and our caregivers alike.
          </p>
        </div>
      </section>

      <section className="section bg-white">
        <div className="mx-auto max-w-7xl px-4 grid lg:grid-cols-2 gap-12 items-center">
          <img
            src="https://images.unsplash.com/photo-1543333995-a78aea2eee50"
            alt="Caregiver assisting a senior outdoors"
            loading="lazy"
            decoding="async"
            className="rounded-2xl shadow-lg object-cover w-full h-[420px]"
          />
          <div>
            <span className="text-[#2E9E6A] font-semibold uppercase tracking-wide text-sm">Who We Are</span>
            <h2 className="font-display font-bold text-3xl text-[#0E2A33] mt-2">Care that feels like family</h2>
            <p className="text-slate-600 mt-4 leading-relaxed">
              {company.legal} was founded to raise the standard of home care in Central Ohio. We believe exceptional care starts with valued caregivers — so we {company.mission.toLowerCase()}
            </p>
            <p className="text-slate-600 mt-4 leading-relaxed">
              Every client receives a personalized care plan, a dedicated care coordinator, and the assurance that help is always a phone call away.
            </p>
            <div className="grid grid-cols-2 gap-6 mt-8">
              {stats.map((s) => (
                <div key={s.label}>
                  <div className="font-display font-extrabold text-3xl text-[#0E5A72]">{s.value}</div>
                  <div className="text-sm text-slate-500">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section brand-gradient-soft">
        <div className="mx-auto max-w-7xl px-4 grid gap-6 md:grid-cols-3">
          {[
            { icon: Target, title: "Our Mission", text: "To deliver compassionate, dependable home care that empowers Ohioans to live safely and with dignity at home." },
            { icon: Eye, title: "Our Vision", text: "To be Ohio's most trusted home care provider — known for outstanding care and an outstanding workforce." },
            { icon: HeartHandshake, title: "Our Values", text: "Compassion, integrity, respect, and community. We care for people the way we'd care for our own family." },
          ].map((c) => {
            const Icon = c.icon;
            return (
              <div key={c.title} className="bg-white rounded-2xl p-8 shadow-sm card-hover">
                <div className="brand-gradient h-12 w-12 rounded-xl grid place-items-center text-white">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="font-display font-bold text-lg text-[#0E2A33] mt-4">{c.title}</h3>
                <p className="text-slate-600 text-sm mt-2 leading-relaxed">{c.text}</p>
              </div>
            );
          })}
        </div>
      </section>
      <CTASection />
    </>
  );
};

export default About;
